import { Alert, Button, DialogContent, DialogContentText } from "@mui/material";
import GenericTable from "common/components/GenericTable/GenericTable";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { ROLE_MAP } from "utils/constants";
import { checkPendingNotification } from "utils/pendingNotification";

const DialogUserRoleContent = ({ selectedUser, handleChangeExternalData }) => {
    const { auth, setAuth } = useAuth();
    const [userRoleEstablishmentList, setUserRoleEstablishmentList] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("");

    const getUserRoleEstablishments = async () => {
        const result = await ApiService.getUserRoleEstablishments({
            user: selectedUser.id,
            pending: 1,
        });
        setUserRoleEstablishmentList(
            result.data.map((ure) => ({
                id: ure.id,
                roleRequested: ure.role,
                establishment: {
                    name: ure.establishment,
                    location: ure.location,
                    province: ure.province,
                },
            }))
        );
    };

    useEffect(() => {
        getUserRoleEstablishments();
    }, []);

    const acceptOrReject = async (ureId, data) => {
        try {
            const res = await ApiService.acceptOrRejectRole(ureId, data);
            getUserRoleEstablishments();
            if (res.status === 200) {
                setAlertText(
                    data.accepted ? "El rol se aceptó con éxito!" : "El rol se rechazó con éxito!"
                );
                setAlertSeverity("success");
            } else {
                setAlertText("Ocurrió un error, intente nuevamente!");
                setAlertSeverity("error");
            }
        } catch (error) {
            console.log(error);
            setAlertText("Ocurrió un error, intente nuevamente!");
            setAlertSeverity("error");
        } finally {
            checkPendingNotification(auth, setAuth);
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
            }, 2500);
        }
    };

    const columns = [
        {
            field: "roleRequested",
            headerName: "Rol Solicitado",
            width: 150,
            valueGetter: (row) => `${ROLE_MAP[row.row.roleRequested]}`,
        },
        {
            field: "establishment",
            headerName: "Establecimiento",
            width: 300,
            renderCell: (params) => (
                <div>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        <li>
                            <strong>Nombre:</strong> {params.row.establishment.name}
                        </li>
                        <li>
                            <strong>Provincia:</strong> {params.row.establishment.province}
                        </li>
                        <li>
                            <strong>Localidad:</strong> {params.row.establishment.location}
                        </li>
                    </ul>
                </div>
            ),
        },
        {
            field: "actions",
            headerName: "Acciones",
            width: 200,
            renderCell: (params) => (
                <div>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={() => acceptOrReject(params.row.id, { accepted: true })}
                    >
                        Aceptar
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        sx={{ marginLeft: "10px" }}
                        onClick={() => acceptOrReject(params.row.id, { accepted: false })}
                    >
                        Rechazar
                    </Button>
                </div>
            ),
        },
    ];

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    <strong>Nombre:</strong> {selectedUser.first_name} {selectedUser.last_name}
                </DialogContentText>
                <DialogContentText>
                    <strong>Email:</strong> {selectedUser.email}
                </DialogContentText>
                <DialogContentText>
                    <strong>DNI:</strong> {selectedUser.dni}
                </DialogContentText>
                <GenericTable
                    rows={userRoleEstablishmentList}
                    columns={columns}
                    disableSelectionOnClick
                    rowHeight={62}
                />
            </DialogContent>
            {showAlert && (
                <Alert
                    sx={{
                        zIndex: 99999,
                        position: "fixed",
                        top: "50%",
                        left: "40%",
                        color: "white",
                        fontWeight: "bold",
                    }}
                    variant="filled"
                    severity={alertSeverity}
                >
                    {alertText}
                </Alert>
            )}
        </>
    );
};

export default DialogUserRoleContent;
